import { render, staticRenderFns } from "./RProductCard.vue?vue&type=template&id=95d60ae2&scoped=true&"
import script from "./RProductCard.vue?vue&type=script&lang=js&"
export * from "./RProductCard.vue?vue&type=script&lang=js&"
import style0 from "./RProductCard.vue?vue&type=style&index=0&id=95d60ae2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d60ae2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
